<div class="modal-header">
  <h4 class="modal-title">{{ "chat.status.title" | translate }}</h4>
  <button
    type="button"
    class="btn-close"
    [attr.aria-label]="'chat.status.cancel' | translate"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <!-- Availability -->
  <h5 class="fs-6 mb-1">{{ "chat.status.availability" | translate }}</h5>
  <p class="text-muted mb-2">
    {{ "chat.status.manualOverrideHint" | translate }}
  </p>

  <!-- One row, one chip per availability — the same select-a-chip language the
       emoji picker below already speaks, instead of a stacked list. -->
  <div
    class="d-flex flex-row gap-2 mb-3"
    role="group"
    [attr.aria-label]="'chat.status.availability' | translate"
  >
    @for (option of availabilityOptions; track option.availability) {
      <button
        type="button"
        class="btn flex-fill d-inline-flex align-items-center justify-content-center gap-2 chat-name"
        [class.btn-primary]="availability === option.availability"
        [class.btn-light]="availability !== option.availability"
        [attr.aria-pressed]="availability === option.availability"
        (click)="selectAvailability(option.availability)"
      >
        <span
          class="chat-status-dialog__dot rounded-circle flex-shrink-0"
          [ngClass]="option.dotClass"
        ></span>
        <span class="text-truncate">{{ option.labelKey | translate }}</span>
        @if (availability === option.availability) {
          <i class="ri-check-line flex-shrink-0" aria-hidden="true"></i>
        }
      </button>
    }
  </div>

  <!-- Custom status -->
  <h5 class="fs-6 mb-2">{{ "chat.status.customStatus" | translate }}</h5>

  <div class="mb-2">
    <label class="form-label">{{ "chat.status.emoji" | translate }}</label>
    <div class="d-flex flex-wrap gap-1">
      <button
        type="button"
        class="btn btn-sm"
        [class.btn-primary]="!statusEmoji"
        [class.btn-light]="!!statusEmoji"
        (click)="selectEmoji('')"
      >
        {{ "chat.status.noEmoji" | translate }}
      </button>
      @for (emoji of emojis; track trackEmoji($index, emoji)) {
        <button
          type="button"
          class="btn btn-sm chat-status-dialog__emoji"
          [class.btn-primary]="statusEmoji === emoji"
          [class.btn-light]="statusEmoji !== emoji"
          [attr.aria-label]="emoji"
          (click)="selectEmoji(emoji)"
        >
          {{ emoji }}
        </button>
      }
    </div>
  </div>

  <div class="mb-2">
    <label class="form-label" for="chatStatusText">{{
      "chat.status.customStatus" | translate
    }}</label>
    <input
      id="chatStatusText"
      type="text"
      class="form-control"
      name="chatStatusText"
      [maxlength]="textMaxLength"
      [placeholder]="'chat.status.textPlaceholder' | translate"
      [attr.aria-label]="'chat.status.textPlaceholder' | translate"
      [(ngModel)]="statusText"
    />
  </div>

  <div class="mb-0">
    <label class="form-label" for="chatStatusExpiry">{{
      "chat.status.expiry" | translate
    }}</label>
    <select
      id="chatStatusExpiry"
      class="form-select"
      name="chatStatusExpiry"
      [disabled]="!hasCustomStatus"
      [(ngModel)]="expiryKey"
    >
      @for (preset of expiryPresets; track preset.key) {
        <option [value]="preset.key">{{ preset.labelKey | translate }}</option>
      }
    </select>
    <span class="help-block"
      ><small class="text-muted">{{
        "chat.status.expiryHint" | translate
      }}</small></span
    >
  </div>

  <div class="d-flex flex-wrap gap-2 mt-3">
    <button
      type="button"
      class="btn btn-sm btn-soft-primary"
      (click)="openPreferences()"
    >
      <i class="ri-notification-3-line me-1"></i
      >{{ "chat.status.preferences" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-sm btn-soft-primary"
      (click)="openTeam()"
    >
      <i class="ri-team-line me-1"></i>{{ "chat.status.team" | translate }}
    </button>
  </div>
</div>

<div class="modal-footer justify-content-between">
  <button
    type="button"
    class="btn btn-soft-danger"
    [disabled]="busy"
    (click)="clear()"
  >
    @if (clearing) {
      <span class="spinner-border spinner-border-sm me-1" role="status"></span>
    } @else {
      <i class="ri-eraser-line me-1"></i>
    }
    {{ "chat.status.clear" | translate }}
  </button>
  <div class="d-flex gap-1">
    <button
      type="button"
      class="btn btn-light"
      [disabled]="busy"
      (click)="close()"
    >
      {{ "chat.status.cancel" | translate }}
    </button>
    <button
      type="button"
      class="btn btn-primary"
      [disabled]="busy"
      (click)="save()"
    >
      @if (submitting) {
        <span
          class="spinner-border spinner-border-sm me-1"
          role="status"
        ></span>
        <span>{{ "chat.status.saving" | translate }}</span>
      } @else {
        <span>{{ "chat.status.save" | translate }}</span>
      }
    </button>
  </div>
</div>
